import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { triggerDownload } from '../../element/attachments/attachmentDownloadActions';
import { trackAttachmentDownload } from '../../element/attachments/attachmentsService';
import useStalledBoolean from '../../utils/react/useStalledBoolean';

import './DownloadButton.scss';

const DownloadButton = ({ children, url, filename, onDownloadStart, onDownloadEnd, elementId, isShare }) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const dispatch = useDispatch();

    // Latch the guard true for a minimum window so a rapid second click after
    // onDownloadEnd can't kick off (and re-track) another download.
    const isDownloadInProgress = useStalledBoolean(isDownloading, 1500);

    const onDownload = (event) => {
        event && event.preventDefault();
        event && event.stopPropagation();
        if (isDownloading || isDownloadInProgress) return;

        trackAttachmentDownload({ url });

        dispatch(
            triggerDownload({
                url,
                filename,
                onDownloadStart: () => {
                    setIsDownloading(true);
                    onDownloadStart && onDownloadStart();
                },
                onDownloadEnd: () => {
                    setIsDownloading(false);
                    onDownloadEnd && onDownloadEnd();
                },
                id: elementId,
                isShare,
            }),
        );
    };

    return (
        <span className="DownloadButton">
            <a className="download-button" onClick={onDownload} href={url}>
                {children}
            </a>
        </span>
    );
};

DownloadButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    url: PropTypes.string,
    filename: PropTypes.string,
    elementId: PropTypes.string,
    onDownloadStart: PropTypes.func,
    onDownloadEnd: PropTypes.func,
    isShare: PropTypes.bool,
};

export default DownloadButton;
